var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainCard',{staticClass:"base-padding",attrs:{"name":"Активные сессии","noBody":""}},[_c('div',{staticClass:"tableWrapper"},[_c('SessionsTable')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }